import { Box } from "@material-ui/core";
import { PatientIcon } from "../../../../../components/icons/PatientIcon";
import { BaseAgreement, DocumentStatus } from "../../../../../models/generated/graphql";
import { TransactionProgressBar } from "../TransactionProgressBar";
import { DocumentRefundGroup, getCombinedScopeIds, getGroupScopes, getProgressInfo, getRefundGroupInfo } from "../utils/map-values";
import refundStyles from "./refund-styles";
import RefundsHeaderEntry from "./RefundsHeaderEntry";
import { InvokeCommentsButton } from "../../messaging/InvokeCommentsButton";

type RefundTableHeaderProps = {
	documentRefundGroup: DocumentRefundGroup;
	baseAgreements: Array<BaseAgreement>;
	documentStatus?: DocumentStatus | null;
	isExposure?: boolean;
	externalFlowDocumentId?: string;
};

const RefundsTableHeader = ({
	documentRefundGroup,
	baseAgreements,
	documentStatus,
	isExposure,
	externalFlowDocumentId,
}: RefundTableHeaderProps) => {
	const { isCaseless, caseEntity, agreement } = getRefundGroupInfo(documentRefundGroup, baseAgreements);
	const { countryScopeId } = getGroupScopes(documentRefundGroup, baseAgreements);
	const { declinedCount, acceptedCount, reviewedCount, total } = getProgressInfo(documentRefundGroup);
	const { refundGroupHeader, refundGroupHeaderLeft, refundGroupHeaderRight } = refundStyles();

	const handleClickCase = (e: React.SyntheticEvent) => {
		e.preventDefault();
		const win = window.open(`/cases/case?id=${caseEntity?.id}`, "_blank") as Window;
		win.focus();
	};

	const handleClickAgreement = (e: React.SyntheticEvent) => {
		e.preventDefault();
		const win = window.open(`/agreements/agreement?id=${agreement?.id}`, "_blank") as Window;
		win.focus();
	};

	return (
		<Box className={refundGroupHeader}>
			<Box className={refundGroupHeaderLeft}>
				{!isCaseless && (
					<>
						<RefundsHeaderEntry labelKey="case" value={caseEntity?.id} onClick={isExposure ? undefined : handleClickCase} />
						<RefundsHeaderEntry labelKey="iin" value={caseEntity?.patientInsuranceId} icon={<PatientIcon />} />
						<RefundsHeaderEntry labelKey="scopeId" value={getCombinedScopeIds({ countryScopeId, includePlaceholder: true })} />
					</>
				)}
				<RefundsHeaderEntry
					tooltip
					labelKey="agreement"
					value={agreement?.name}
					onClick={isExposure ? undefined : handleClickAgreement}
					dot={false}
				/>
			</Box>
			<Box className={refundGroupHeaderRight}>
				{documentStatus !== DocumentStatus.WorkingDraft && (
					<TransactionProgressBar
						declinedCount={declinedCount}
						acceptedCount={acceptedCount}
						reviewedCount={reviewedCount}
						total={total}
						smaller
					/>
				)}
				<InvokeCommentsButton
					caseId={documentRefundGroup.case?.id}
					agreementId={isCaseless ? agreement?.id : undefined}
					style={{ marginRight: -16 }}
				/>
			</Box>
		</Box>
	);
};

export default RefundsTableHeader;
